<template>
  <div class="jwt-chat-empty">
    <div class="jwt-chat-empty__content">
      <div class="jwt-chat-empty__icon">
        <img :src="require('@/assets/image/no_data.png')" alt="" />
      </div>
      <div class="jwt-chat-empty__title">初始化失败</div>
      <el-button class="jwt-chat-empty__reload" type="primary" size="small" @click="load"> 重新加载 </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatEmpty",
  methods: {
    load() {
      // 刷新当前页面
      window.location.reload();
    }
  }
};
</script>

<style lang="scss">
.jwt-chat-empty {
  width: 100%;
  height: 100%;
  min-height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f9fc;
  box-sizing: border-box;
  padding: 32px;
}

.jwt-chat-empty__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.jwt-chat-empty__icon {
  width: 128px;
  height: 128px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 82, 217, 0.05);
  border: 1px solid rgba(0, 82, 217, 0.1);

  img {
    width: 96px;
    height: 96px;
    object-fit: contain;
    display: block;
  }
}

.jwt-chat-empty__title {
  margin-top: 20px;
  color: #1f2937;
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
}

.jwt-chat-empty__desc {
  margin-top: 8px;
  color: #8b95a5;
  font-size: 14px;
  line-height: 22px;
}
.jwt-chat-empty__reload {
  margin-top: 12px;
  min-width: 96px;
  background: linear-gradient(90deg, #000dff 0%, #44a5ff 100%) !important;
}
@media screen and (max-width: 480px) {
  .jwt-chat-empty {
    min-height: 260px;
    padding: 24px 16px;
  }

  .jwt-chat-empty__icon {
    width: 104px;
    height: 104px;
    border-radius: 20px;

    img {
      width: 78px;
      height: 78px;
    }
  }

  .jwt-chat-empty__title {
    margin-top: 16px;
    font-size: 17px;
    line-height: 24px;
  }

  .jwt-chat-empty__desc {
    font-size: 13px;
    line-height: 20px;
  }
  .jwt-chat-empty__reload {
    margin-top: 12px;
    min-width: 96px;
    background: linear-gradient(90deg, #000dff 0%, #44a5ff 100%) !important;
  }
}
</style>
